// frontend/src/components/Layout/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Flex, Text, Button, Avatar,
  Menu, MenuButton, MenuList, MenuItem, MenuDivider,
  IconButton,
} from '@chakra-ui/react';
import { FiChevronDown, FiUser, FiLogOut, FiMenu } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';

const Header = ({ onMenuClick, isMobile }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <Box bg="white" borderBottom="1px" borderBottomColor="gray.200" px={{ base: 3, md: 6 }} py={3}>
      <Flex justify="space-between" align="center">
        <Flex align="center" gap={3}>
          {isMobile && (
            <IconButton
              icon={<FiMenu />}
              variant="ghost"
              aria-label="Menu"
              onClick={onMenuClick}
              size="md"
            />
          )}
          <Box>
            <Text fontSize={{ base: 'lg', md: '2xl' }} fontWeight="bold" color="eecf.500" lineHeight={1.2}>
              {isMobile ? 'EECF' : 'Administration EECF'}
            </Text>
            {!isMobile && (
              <Text fontSize="sm" color="gray.500">Gestion de l'association cultuelle</Text>
            )}
          </Box>
        </Flex>

        <Menu>
          <MenuButton as={Button} rightIcon={<FiChevronDown />} variant="ghost" px={{ base: 2, md: 4 }}>
            <Flex align="center">
              <Avatar size="sm" name={`${user?.prenom} ${user?.nom}`} mr={{ base: 0, md: 2 }} />
              {!isMobile && <Text fontSize="sm">{user?.prenom} {user?.nom}</Text>}
            </Flex>
          </MenuButton>
          <MenuList>
            <MenuItem icon={<FiUser />} onClick={() => navigate('/profile')}>Mon profil</MenuItem>
            <MenuDivider />
            <MenuItem icon={<FiLogOut />} onClick={logout}>Se déconnecter</MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Box>
  );
};

export default Header;